import { Router } from '@angular/router';

export function buildClientDetailReturnUrl(router: Router, activeTab: string): string {
  const baseUrl = router.url.split('?')[0];
  return `${baseUrl}?clientTab=${activeTab}`;
}

export function navigateToRelatedClient(
  router: Router,
  clientId: number,
  activeTab: string
): void {
  const returnUrl = router.url.split('?')[0];
  router.navigate(['/clients/detail', clientId], {
    queryParams: {
      returnUrl,
      returnClientTab: activeTab,
    },
  });
}

export function resolveClientDetailBackUrl(returnUrl: string, returnClientTab?: string): string {
  if (returnUrl.includes('clientTab=')) {
    return returnUrl;
  }
  if (returnClientTab) {
    return `${returnUrl}?clientTab=${returnClientTab}`;
  }
  return returnUrl;
}

export function parseClientDetailBackNavigation(
  backUrl: string
): { clientId: string; clientTab?: string } | null {
  const match = backUrl.match(/^\/clients\/detail\/([^?]+)(?:\?(.*))?$/);
  if (!match) {
    return null;
  }

  let clientTab: string | undefined;
  if (match[2]) {
    const tabParam = match[2].split('&').find(part => part.startsWith('clientTab='));
    clientTab = tabParam ? decodeURIComponent(tabParam.split('=')[1]) : undefined;
  }

  return { clientId: match[1], clientTab };
}
